import { ENTRYPOINTS_ACTIONS } from "../constants/action-types";

const initialState = {
  synchronizationData: []
};

const entrypointReducer = (state = initialState, action) => {
  switch (action.type) {
    case ENTRYPOINTS_ACTIONS.SYNCHRONIZATION_ENDPOINT_QUERY_START:
      return Object.assign({}, state, {
        synchronizationData: []
      });
    case ENTRYPOINTS_ACTIONS.SYNCHRONIZATION_ENDPOINT_QUERY_SUCCESS:
      return Object.assign({}, state, {
        synchronizationData: action.payload
      });
    case ENTRYPOINTS_ACTIONS.SYNCHRONIZATION_ENDPOINT_QUERY_ERROR:
      return Object.assign({}, state, {
        synchronizationData: []
      });
    default:
      return state;
  }
};

export default entrypointReducer;
